export default "__VITE_ASSET__CHIZXv1A__"